/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppConfig } from 'app/models/auth-config';
import { AppConsts } from 'app/shared/services/app-const';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function bootstrapFailed(val: any) {
  console.error('bootstrap-fail', val);
}

fetch('/api/configuration')
  .then(response => response.json())
  .then((config: AppConfig) => {
    AppConsts.appConfig = config;
    AppConsts.authConfig = config.authConfig;
    AppConsts.webConfig = config.appConfig;

    if (!config) {
      bootstrapFailed(config);
      return;
    }

    platformBrowserDynamic().bootstrapModule(AppModule).catch(bootstrapFailed);
  })
  .catch(bootstrapFailed);
